import DodoneNextLink from 'app/dodones/shared/NextLink'
import DodonesListItem from 'app/dodones/list/Item'
import { parseISO } from 'date-fns'
import DayCount from 'app/components/DayCount'

const Percentage = ({ dodone }) => {
  const totalCount = dodone.children.length

  const closedCount = useMemo(() => {
    return dodone.children.filter((child) => {
      return child.isClosed
    }).length
  })

  const percentage = totalCount === 0 ? 0 : (closedCount / totalCount) * 100
  const contents = closedCount > 0 ? `${ closedCount } of ${ totalCount }` : ''

  return (
    <div className="percentage-bar mb-d">
      <div className="percentage-bar-fill" style={{ width: `${percentage}%` }}>
        { contents }
      </div>
    </div>
  )
}

const NoSmoking = () => {
  const dateString = '2026-05-27T10:00:00Z'
  const parsedDate = parseISO(dateString)

  return <DayCount startedAt={ parsedDate } after="SEM FUMAR" />
}

const NoGaming = () => {
  const dateString = '2026-05-30T10:00:00Z'
  const parsedDate = parseISO(dateString)

  return <DayCount startedAt={ parsedDate } after="SEM JOGAR" />
}

const Dashboard = ({ dodone }) => {
  const ongoingDodone = useMemo(() => {
    return dodone.children.find((child) => {
      return child.isOngoing
    })
  })

  return <div className="flex-1 fcol">
           <Percentage dodone={ dodone } />
           { ongoingDodone ? <DodonesListItem dodone={ ongoingDodone } /> : <DodoneNextLink currentDodoneId={ dodone.id } /> }
           <div className="mb-d">
             <NoSmoking />
           </div>
           <NoGaming />
         </div>
}

export default Dashboard
